/* eslint-disable max-lines */
// TODO: file is too long :(
import { createFormSelectionControl } from '@vfde-brix/ws10/form-selection-control';
import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';
import { getFormErrors } from '../../../helpers/windowObject.helper';
import { validateForm } from './validateForm.helper';
import { setValidationErrorVisibility } from './notification.helper';
import { debugInfo } from '../../../utils/debug';
import { HtmlId, LmsInputId } from '../../../enums/elementId';
import { ContactMethod, EventString } from '../enum';

const getInputElementArray = (
    containerElement?: HTMLElement | null,
    containerId?: HtmlId
): HTMLInputElement[] => {
    if (!containerElement) {
        containerElement = document.getElementById(containerId || '');
    }

    if (!containerElement) {
        debugInfo('Failed to get input elements.');
        return [];
    }

    return Array.from(containerElement.getElementsByTagName('input'));
};

/** Workaround to validate form-control-input */
export const validateFormControlInput = (
    containerElement: HTMLDivElement,
    inputArray?: HTMLInputElement[]
): boolean => {
    // check if validation needed
    if (containerElement.dataset?.noValidation) {
        return true;
    }

    if (!inputArray) {
        inputArray = getInputElementArray(containerElement);
    }

    const errorMsgElement = containerElement
        .getElementsByClassName('ws10-form-selection-control__error-message')[0];

    for (const input of inputArray) {
        if (input.checked) {
            // found one checked input
            errorMsgElement.classList.toggle(CLASSNAME_HIDDEN, true);
            return true;
        }
    }

    // one element has to be checked otherwise it is false
    errorMsgElement.innerHTML = getFormErrors().required;
    errorMsgElement.classList.toggle(CLASSNAME_HIDDEN, false);
    return false;
};

const getRadioButtonOrCheckboxValue = (inputCount: Number, input: HTMLInputElement, event: Event) => {
    // checkbox
    if (1 === inputCount) {
        return input.checked;
    }

    // radiobutton
    return (event.target as HTMLInputElement).value;
};

const addFormControlInputEventListener = (
    input: HTMLInputElement,
    containerElement: HTMLDivElement,
    inputArray: HTMLInputElement[],
    onChange: Function
) => {
    input.addEventListener(EventString.CHANGE, (event: Event) => {
        event.preventDefault();

        const valid = validateFormControlInput(containerElement, inputArray);
        valid && onChange(
            getRadioButtonOrCheckboxValue(
                inputArray.length,
                input,
                event
            )
        );
    });
};

/** Mount workaround to validator for form-control-input on page load */
export const mountFormControlInput = (
    containerId: string,
    onChange: Function,
    validationsNeeded: boolean = true,
    textContent?: string,
) => {
    const containerElement = document.getElementById(containerId) as HTMLDivElement;

    if (!containerElement) {
        debugInfo('Container not found by id: ', containerId);
        return;
    }

    // workaround because NO_PATTERN_BUSINESS_LOGIC causes an exception in the component
    const dummyBusinessLogic = { onChange: () => {} };
    createFormSelectionControl(containerElement, dummyBusinessLogic);

    const inputArray = Array.from(containerElement.getElementsByTagName('input'));

    // mark form control input to not perform validation on submit
    if (!validationsNeeded) {
        containerElement.dataset.noValidation = 'true';
    }

    for (const input of inputArray) {
        addFormControlInputEventListener(input, containerElement, inputArray, onChange);
    }

    if (!textContent) {
        return;
    }

    const textElement = containerElement.querySelector('.ws10-form-selection-control__text p');

    if (!textElement) {
        debugInfo('Could not update text element in Form Control Input:', containerElement);
        return;
    }

    textElement.innerHTML = textContent;
};

const validateContactField = (contactMethod: ContactMethod) => {
    const containerContactMethod = document.getElementById(LmsInputId.ID_WRAPPER_INPUT_CONTACT_METHOD);

    if (!containerContactMethod) {
        debugInfo('Validate contact field failed!');
        return false;
    }

    const contactMethodInput = containerContactMethod
        .querySelector('input[name=contact-method]:checked') as HTMLInputElement;

    if (!contactMethodInput?.value) {
        return true;
    }

    let inputContainer;

    switch (contactMethodInput.value) {
        case 'phone':
            if (contactMethod === ContactMethod.CONSULT_AT_HOME) {
                return true;
            }

            inputContainer =
                document.getElementById(LmsInputId.ID_WRAPPER_INPUT_CONTACT_NUMBER) as HTMLDivElement;
            break;
        case 'house':
            if (contactMethod === ContactMethod.CALL_BACK) {
                return true;
            }

            inputContainer = document.getElementById(LmsInputId.ID_WRAPPER_INPUT_CITY) as HTMLDivElement;
            break;
        case 'email':
            if (contactMethod === ContactMethod.EMAIL) {
                return true;
            }

            inputContainer = document.getElementById(LmsInputId.ID_WRAPPER_INPUT_EMAIL) as HTMLDivElement;
            break;
        default:
            return true;
    }

    const inputElement: HTMLInputElement = inputContainer.getElementsByTagName('input')[0];
    return !!inputElement.value;
};

// TODO: remove if not needed! START
/** Custom validator for phone input, rule: Phone is mandatory, if Next_action is set to "Call back" */
export const validateContactPhoneInput = () => { return validateContactField(ContactMethod.CALL_BACK); };

/** Custom validator for city input, rule: City is mandatory, if Next_action is set to "Consult at home" */
export const validateContactCityInput = () => { return validateContactField(ContactMethod.CONSULT_AT_HOME); };

/** Custom validator for email input, rule: Email is mandatory, if Next_action is set to "E-Mail" */
export const validateContactEmailInput = () => { return validateContactField(ContactMethod.EMAIL); };
// TODO: remove if not needed! END

/** Contact method tranfrom  */
export const transformContactMethod = (inputValue: string) => {
    switch (inputValue) {
        case 'phone': return ContactMethod.CALL_BACK;
        case 'house': return ContactMethod.CONSULT_AT_HOME;
        case 'email': return ContactMethod.EMAIL;
    }
};

/** Split house number and house number extra, example: 1a -> hnr: 1, hnrExtra: a */
export const separateHouseNumber = (hnr: string) => {
    const number = hnr.split(/(\d+)/g);
    return {
        streetNr: number[1],
        streetSuffix: hnr.replace(number[1], ''),
    };
};

export const submitValidator = (action: any) => {
    // custom validators before submit
    const isValid = validateForm();

    if (!isValid) {
        // show form validation error
        setValidationErrorVisibility(true);
        return;
    }

    setValidationErrorVisibility(false);
    action.submitForm();
};
